import React from 'react';
import { TipTapRender } from './renderer';
import cn from 'classnames';
import { useHandlers } from './useHandlers';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import isEmpty from 'lodash/isEmpty';
import { getContentFromStorage } from '../utils/tiptap';
import baseStyles from './styles/base.scss';
const Viewer = ({ contentJson, className, externalRenderers, extensionConfig, cookieType, defaultSize, presetId })=>{
    const handlers = useHandlers(extensionConfig);
    const { ref, dimensions } = useMeasureElementCookie(cookieType, {
        cookieDim: 'width',
        defaultSize
    });
    if (!contentJson) {
        return null;
    }
    // Allow both our full wrapped docs and direct nodes
    const content = structuredClone(getContentFromStorage(contentJson));
    if (isEmpty(content)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: cn(className, baseStyles['base-tiptap'])
    }, /*#__PURE__*/ React.createElement(TipTapRender, {
        presetId: presetId,
        node: content,
        handlers: handlers,
        externalRenderers: externalRenderers,
        extensionConfig: extensionConfig,
        containerWidth: dimensions.width
    }));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map